import { createContext, useReducer } from 'react'
import historyReducer from './HistoryReducer'

const HistoryContext = createContext()

export const HistoryProvider = ({ children }) => {
  const initialState = {
    histories: [],
    history: {},
    loading: false,
  }

  const [state, dispatch] = useReducer(historyReducer, initialState)

  return (
    <HistoryContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </HistoryContext.Provider>
  )
}

export default HistoryContext
